// アコーディオンの要素を取得
const accordionItems = document.querySelectorAll(".ac");

// 各アイテムにクリックイベントリスナーを追加
accordionItems.forEach((item) => {
  const header = item.querySelector(".ac-header");
  const content = item.querySelector(".ac-content");

  header.addEventListener("click", function () {
    // 他のアコーディオンをすべて閉じる
    accordionItems.forEach((otherItem) => {
      if (otherItem !== item) {
        const otherContent = otherItem.querySelector(".ac-content");
        otherItem.classList.remove("active");
        otherContent.classList.remove("active");
        otherContent.style.maxHeight = null;
      }
    });

    // クリックされたアイテムの表示状態を切り替える
    item.classList.toggle("active");
    content.classList.toggle("active");

    // コンテンツの表示状態を切り替える
    if (content.classList.contains("active")) {
      // コンテンツの高さを取得して設定
      content.style.maxHeight = content.scrollHeight + "px";
    } else {
      // コンテンツの高さをリセット
      content.style.maxHeight = null;
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  let url = new URL(window.location.href);
  let baseUrl = `${url.protocol}//${url.host}`;
  let currentVariant = "";

  const buckleForm = document.querySelector("#belt_buckle_variation");
  if (buckleForm) {
    redirectUrl(buckleForm, baseUrl, currentVariant);
  }

  const selectButton = document.getElementById("selected-product-button");
  if (selectButton) {
    var popup = document.querySelector(".popup");
    var dropdownIcon = selectButton.querySelector("svg");

    selectButton.addEventListener("click", function (event) {
      event.stopPropagation();
      popup.classList.toggle("show");
      toggleDropdownIcon();
    });
    document.addEventListener("click", function () {
      if (popup.classList.contains("show")) {
        popup.classList.remove("show");
        resetDropdownIcon();
      }
    });
  }

  function toggleDropdownIcon() {
    if (popup.classList.contains("show")) {
      dropdownIcon.style.transform = "rotate(180deg)";
    } else {
      dropdownIcon.style.transform = "rotate(0deg)";
    }
  }

  function resetDropdownIcon() {
    dropdownIcon.style.transform = "rotate(0deg)";
  }
});
const redirectUrl = (buckleElement, baseurl, currentVariant) => {
  if (buckleElement) {
    const buttons = buckleElement.querySelectorAll("a.option");
    let variant_id = "";
    let productUrl = "";
    buttons.forEach((button) => {
      button.addEventListener("click", async (event) => {
        event.preventDefault();
        let targetElement = event.target;
        productUrl = targetElement.getAttribute('data-url');
        
        if (
          document.querySelector("variant-option-value") &&
          document.querySelector(".dropdown_box button span")
        ) {
          currentVariant =
          document.querySelector("variant-option-value").textContent +
          " / " +
          document.querySelector(".dropdown_box button span").textContent;
        }
        let url = `${baseurl}${button.getAttribute("data-url")}.js`;

        const productObject = await getProductJson(url);
        const nextProduct = productObject.variants;

        nextProduct.forEach((element) => {
          if (element.title == currentVariant) {
            variant_id = element.id;
            productUrl = `${baseurl}${button.getAttribute(
              "data-url"
            )}?variant=${variant_id}`;
            return;
          }
        });
        if (productUrl == "") {
          productUrl = `${baseurl}${button.getAttribute("data-url")}`;
          window.location.replace(productUrl);
        } else {
          window.location.replace(productUrl);
        }
      });
    });
  }
};

const getProductJson = async (url) => {
  try {
    const response = await axios({
      headers: {
        "Content-Type": "application/json",
      },
      method: "GET",
      url: url,
    });
    return response.data;
  } catch (error) {
    console.log(error);
    throw new Error("Failed to get product JSON.");
  }
};